<template>
  <div>
    <div class="mt-order-top" style="height: auto;">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单搜索：">
          <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
        </el-form-item>
        <el-form-item label="订单类型：">
          <el-select v-model="searchForm.deliveryType" placeholder="请选择" class="mt-search-width">
            <el-option
              v-for="item in deliveryTypeArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间筛选：">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付时间：">
          <el-date-picker
            v-model="searchForm.datePay"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="完成时间：">
          <el-date-picker
            v-model="searchForm.dateComplete"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="基地筛选：">
          <el-select v-model="searchForm.journeyBaseId" placeholder="请选择" class="mt-search-width">
            <el-option
              v-for="item in journeyBaseIdArr"
              :key="item.id"
              :label="item.baseName"
              :value="item.id">
            </el-option>
          </el-select>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-button v-loading.fullscreen.lock="fullscreenLoading">批量发货</el-button> -->
      <el-button @click="exportExcelBtn" v-loading.fullscreen.lock="fullscreenLoading">数据导出</el-button>
    </div>
    <div>
      <el-table
        :data="infoList"
        style="width: 100%">
        <el-table-column
          align="center"
          prop="orderNo"
          label="订单号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="baseName"
          label="基地名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realName"
          label="昵称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="deliveryType"
          label="订单类型">
          <template slot-scope="scope">
            <span>{{scope.row.deliveryType == 1 ? '自提订单' : scope.row.deliveryType == 2 ? '同城配送' : '配送订单'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="goodsOrderGoodsList"
          width="450"
          label="商品信息">
          <template slot-scope="scope">
            <div class="" v-for="(item,index) in scope.row.goodsOrderGoodsList" :key="index">
              <el-image
                style="width: 32px;"
                :src="item.thumb"
                :preview-src-list="[item.thumb]"
                fit="contain">
                </el-image>
                <span>{{item.goodsName}}-{{item.specName}}</span>
                <span>x{{item.goodsNumber}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderMoney"
          label="订单金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realPayMoney"
          label="支付金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="paySuccessTimeStr"
          label="支付时间">
        </el-table-column>
        <el-table-column
          align="center"
          prop="overTime"
          label="完成时间">
          <template slot-scope="scope">
            <span>{{scope.row.overTime == null ? '--' : scope.row.overTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderStatus"
          label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus === 0 && tabCurrent !== 4" style="color: #FF5733;">待支付</span>
            <span v-if="scope.row.orderStatus === 1 && tabCurrent !== 4" style="color: #FF5733;">
              待发货 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}
            </span>
            <span v-if="scope.row.orderStatus === 2 && tabCurrent !== 4" style="color: #E6A23C;">{{scope.row.deliveryType == 1 ? '待核销' : '待收货'}} {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 3 && tabCurrent !== 4" style="color: #999999;">{{scope.row.deliveryType == 1 ? '已核销' : '已完成'}} {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="tabCurrent === 4" style="color: #FF5733;">待评价 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 4" style="color: #999999;">已关闭 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 5" style="color: #FF5733;">拼团中 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 91" style="color: #E6A23C;">已退款</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="refundMoney"
          label="退款金额">
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          width="240"
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="detailOpenBtn(scope.row.id)">详情</el-button>
            <el-button style="display: none;" v-if="scope.row.orderStatus == 1 && scope.row.deliveryType == 0" @click="sendOpenBtn(scope.row.id)" type="text" size="small">发货</el-button>
            <el-button v-if="scope.row.orderStatus == 1 && scope.row.deliveryType == 2" @click="sendOpenBtn(scope.row.id)" type="text" size="small">发货</el-button>
            <el-button v-if="scope.row.orderStatus == 2 && scope.row.deliveryType == 1" @click="writeOffBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">核销</el-button>
            <el-button v-if="scope.row.orderStatus == 2 && scope.row.deliveryType == 0" @click="watchWlBtn(scope.row.id)" type="text" size="small">查看物流</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
    </div>
    <!-- 订单详情弹窗 -->
    <el-drawer
      size="960px"
      :visible.sync="detailShow"
      :with-header="false">
      <order-detail :infoId="infoId" @sendOrderInfo="sendOrderGetValue"></order-detail>
    </el-drawer>
    <!-- 订单发货弹窗 -->
    <el-dialog
      title="订单发货"
      :visible.sync="sendOrderShow"
      width="960px">
      <order-send :infoId="infoId" :goodsData="goodsData" @sendOrderSave="sendOrderSaveGetValue" @sendGoodsData="sendGoodsGetValue"></order-send>
    </el-dialog>
    <!-- 选择商品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsListShow"
      width="960px">
      <goods-list :infoId="infoId" @choosedGoodsData="choosedGoodsDataGetValue"></goods-list>
    </el-dialog>
    <!-- 查看物流弹窗 -->
    <el-drawer
      :with-header="false"
      :visible.sync="wlOrderShow"
      size="960px">
      <order-wl :infoId="infoId"></order-wl>
    </el-drawer>
  </div>
</template>

<script>
import { querySeleniumJourneyOrderPageList, writeOutOrder, orderBasesExportExcel, saveGoodsOrderSend } from '@/api/order'
import { queryAllSeleniumJourneyBaseList } from '@/api/xyj'
import OrderDetail from './Detail.vue'
import OrderSend from './Send.vue'
import GoodsList from './GoodsList.vue'
import OrderWl from './OrderWl.vue'
export default {
  name: 'OrderSingle',
  components: {
    OrderDetail,
    OrderSend,
    GoodsList,
    OrderWl
  },
  props: {
    tabCurrent: {
      type: Number,
      default: 99
    }
  },
  watch: {
    "tabCurrent"(newVal, oldVal) {
      this.currentPage = 1;
      this.getInfoList();
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        deliveryType:'',
        date:['', ''],
        datePay:['', ''],
        dateComplete:['', ''],
        journeyBaseId:''
      },
      deliveryTypeArr:[{
        value:1,
        label:'自提订单'
      }, {
        value:0,
        label:'配送订单'
      }],
      journeyBaseIdArr:[],
      activeName:'first',
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:'',
      // 订单详情
      detailShow:false,
      // 订单发货弹窗
      sendOrderShow:false,
      // 选择商品弹窗
      goodsListShow:false,
      goodsData:[],
      // 查看物流弹窗
      wlOrderShow:false
    }
  },
  mounted () {
    var that = this;
    that.journeyBaseIdFun();
    // console.log(that.tabCurrent,'tabCurrent')
    that.getInfoList();
  },
  methods: {
    /* 取子组件"OrderDetail"传值 */
    sendOrderGetValue(sendOrderShow, infoId){
      // console.log(sendOrderShow,'sendOrderShow', infoId);
      if(sendOrderShow == 1){
        this.detailShow = false;
      }
      this.infoId = infoId;
      this.sendOrderShow = true;
    },
    /* 取子组件"OrderSend"传值 */
    sendOrderSaveGetValue(sendOrderShow, infoId){
      // console.log(sendOrderShow,'sendOrderShow', infoId);
      if(sendOrderShow == 2){
        this.getInfoList();
      }
      this.infoId = infoId;
      this.sendOrderShow = false;
    },
    /* 取子组件"OrderSend"传值-选择商品 */
    sendGoodsGetValue(goodsListShow, infoId){
      // console.log(goodsListShow,'goodsListShow', infoId);
      this.infoId = infoId;
      this.goodsListShow = true;
      this.sendOrderShow = false;
    },
    /* 取子组件"GoodsList"传值 */
    choosedGoodsDataGetValue(goodsData){
      this.goodsData = goodsData;
      this.goodsListShow = false;
      this.sendOrderShow = true;
    },
    // 获取所有基地数据
    journeyBaseIdFun(){
      var that = this;
      queryAllSeleniumJourneyBaseList({}).then((res) => {
          if (res.errorCode === '0000') {
            var data = res.data;
            that.journeyBaseIdArr = data;
          }
        });
    },
    // 导出操作
    exportExcelBtn(){
      let that = this
      let deliveryType = that.searchForm.deliveryType
      let searchName = that.searchForm.name
      let journeyBaseId = that.searchForm.journeyBaseId
      let tabCurrent = that.tabCurrent
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let startPaySuccessDate = ''
      let endPaySuccessDate = ''
      if (that.searchForm.datePay !== null) {
        startPaySuccessDate = that.searchForm.datePay[0]
        endPaySuccessDate = that.searchForm.datePay[1]
      }
      let startOverDate = ''
      let endOverDate = ''
      if (that.searchForm.dateComplete !== null) {
        startOverDate = that.searchForm.dateComplete[0]
        endOverDate = that.searchForm.dateComplete[1]
      }
      var passData = {
        webSearchQuery: searchName,
        deliveryType: deliveryType,
        startCreateDate: startDate,
        endCreateDate: endDate,
        startPaySuccessDate: startPaySuccessDate,
        endPaySuccessDate: endPaySuccessDate,
        startOverDate: startOverDate,
        endOverDate: endOverDate,
        orderStatus:tabCurrent,
        journeyBaseId:journeyBaseId
      }
      that.fullscreenLoading = true;
      orderBasesExportExcel(passData).then((res) => {
        that.fullscreenLoading = false;
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '订单列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    // 发货弹窗-打开操作
    sendOpenBtn(infoId){
      this.infoId = infoId;
      // this.goodsData = [];
      // this.sendOrderShow = true;
      var that = this;
      that.$confirm('是否确认发货？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        saveGoodsOrderSend({ orderId: infoId}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            that.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 查看物流弹窗-打开操作 */
    watchWlBtn(infoId){
      this.infoId = infoId;
      this.wlOrderShow = true;
    },
    /* 打开详情操作 */
    detailOpenBtn(infoId){
      this.infoId = infoId;
      this.detailShow = true;
    },
    /* 核销操作 */
    writeOffBtn(infoId){
      var that = this;
      this.$confirm('是否核销当前选择的商品？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 执行保存相关操作
          that.fullscreenLoading = true;
          writeOutOrder({id:infoId}).then((res) => {
            that.fullscreenLoading = false;
            if (res.errorCode === '0000') {
              that.$message.error(res.msg);
              that.getInfoList();
            }
            if (res.errorCode === '1001') {
              that.$message.error(res.msg);
            }
          });
        })
        .catch(action => {
          if(action === 'cancel'){
            // 执行打印相关操作
          }
        });
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let deliveryType = that.searchForm.deliveryType
      let searchName = that.searchForm.name
      let journeyBaseId = that.searchForm.journeyBaseId
      let tabCurrent = that.tabCurrent
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let startPaySuccessDate = ''
      let endPaySuccessDate = ''
      if (that.searchForm.datePay !== null) {
        startPaySuccessDate = that.searchForm.datePay[0]
        endPaySuccessDate = that.searchForm.datePay[1]
      }
      let startOverDate = ''
      let endOverDate = ''
      if (that.searchForm.dateComplete !== null) {
        startOverDate = that.searchForm.dateComplete[0]
        endOverDate = that.searchForm.dateComplete[1]
      }
      var passData = {
        webSearchQuery: searchName,
        deliveryType: deliveryType,
        startCreateDate: startDate,
        endCreateDate: endDate,
        pageNum: page,
        pageSize: that.limitLength,
        orderStatus:tabCurrent,
        startPaySuccessDate: startPaySuccessDate,
        endPaySuccessDate: endPaySuccessDate,
        startOverDate: startOverDate,
        endOverDate: endOverDate,
        journeyBaseId:journeyBaseId
      }
      querySeleniumJourneyOrderPageList(passData).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xyj/components/OrderSingle.vue